const getters = {
  quote: (state) => {
    return state.quote
  }
}

export default getters



// WEBPACK FOOTER //
// ./src/store/modules/raceQuote/getters.js